import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { FindParticipantsForRebiddingQueryResponse, FindParticipantsForRebiddingQueryParams } from "../../types/FindParticipantsForRebidding";

/**
     * @link /api/purchase-tenders/private/v1/participants/view_for-rebidding
     */
export async function findParticipantsForRebidding (params: FindParticipantsForRebiddingQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<FindParticipantsForRebiddingQueryResponse>["data"]> {
    const { data: resData } = await client<FindParticipantsForRebiddingQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/private/v1/participants/view_for-rebidding`,
        params,
        ...options
    });
    
    return resData;
};